// extracted by mini-css-extract-plugin
export default {"header":"Form_header__YPcF6","img":"Form_img__OEAk-","item":"Form_item__TMWqJ"};